import { defineComponent as x, useId as g, computed as k, watch as y, nextTick as V, createElementBlock as h, openBlock as n, Fragment as C, createElementVNode as m, createVNode as R, createBlock as f, createCommentVNode as p, normalizeClass as _, unref as o } from "vue";
import { ServerVariablesForm as B } from "@scalar/api-client/components/Server";
import { ScalarMarkdown as E } from "@scalar/components";
import { emitCustomEvent as b } from "@scalar/workspace-store/events";
import { templateRef as N } from "@vueuse/core";
import F from "./Selector.vue.js";
const U = ["id"], w = {}, q = /* @__PURE__ */ x({
  ...w,
  __name: "ServerSelector",
  props: {
    xSelectedServer: {},
    servers: {}
  },
  setup(t) {
    const s = g(), d = (e) => {
      b(a.value, "scalar-update-selected-server", {
        value: e
      });
    }, S = (e, l) => {
      a.value && b(
        a.value,
        "scalar-update-selected-server-variables",
        { key: e, value: l }
      );
    }, r = k(() => t.servers.find((e) => e.url === t.xSelectedServer));
    y(
      () => t.servers,
      (e) => {
        e.length && (t.xSelectedServer || V(() => {
          d(e[0].url);
        }));
      },
      { immediate: !0 }
    );
    const a = N("containerRef");
    return (e, l) => {
      var u, i, c, v;
      return n(), h(C, null, [
        l[0] || (l[0] = m("label", { class: "bg-b-2 flex h-8 items-center rounded-t-lg border border-b-0 px-3 py-2.5 font-medium" }, " Server ", -1)),
        m("div", {
          id: o(s),
          ref_key: "containerRef",
          ref: a,
          class: _(["border", {
            "rounded-b-lg": !((u = r.value) != null && u.description) && !((i = r.value) != null && i.variables)
          }])
        }, [
          e.servers.length ? (n(), f(F, {
            key: 0,
            servers: e.servers,
            target: o(s),
            xSelectedServer: e.xSelectedServer,
            "onUpdate:modelValue": d
          }, null, 8, ["servers", "target", "xSelectedServer"])) : p("", !0)
        ], 10, U),
        R(o(B), {
          layout: "reference",
          variables: (c = r.value) == null ? void 0 : c.variables,
          "onUpdate:variable": S
        }, null, 8, ["variables"]),
        (v = r.value) != null && v.description ? (n(), f(o(E), {
          key: 0,
          class: "text-c-3 rounded-b-lg border border-t-0 px-3 py-1.5",
          value: r.value.description
        }, null, 8, ["value"])) : p("", !0)
      ], 64);
    };
  }
});
export {
  q as default
};
